import React, { useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'

const DEFAULT_EMOJIS = [
  { value: '😀', label: 'Smile', keywords: ['smile', 'sorriso', 'happy', 'felice', 'joy', 'gioia'] },
  { value: '😁', label: 'Grin', keywords: ['grin', 'sorriso grande', 'happy', 'felicità', 'positive', 'positivo'] },
  { value: '😂', label: 'Laugh', keywords: ['laugh', 'risata', 'lol', 'funny', 'divertente', 'comic'] },
  { value: '🤣', label: 'Rolling Laugh', keywords: ['rofl', 'risata', 'divertente', 'joke', 'barzelletta', 'umorismo'] },
  { value: '😊', label: 'Blush', keywords: ['blush', 'timido', 'gentle', 'dolce', 'friendly', 'amichevole'] },
  { value: '🙂', label: 'Slight Smile', keywords: ['smile', 'sorriso', 'neutral', 'neutro', 'ok'] },
  { value: '😉', label: 'Wink', keywords: ['wink', 'occhiolino', 'hint', 'suggerimento', 'playful', 'giocoso'] },
  { value: '😍', label: 'Love Eyes', keywords: ['love', 'amore', 'heart', 'cuore', 'great', 'fantastico'] },
  { value: '🥳', label: 'Celebrate', keywords: ['celebrate', 'festeggiare', 'party', 'festa', 'success', 'traguardo'] },
  { value: '😎', label: 'Cool', keywords: ['cool', 'top', 'confident', 'sicuro', 'style', 'stile'] },
  { value: '🤩', label: 'Star Eyes', keywords: ['amazing', 'incredibile', 'wow', 'eccellente', 'enthusiastic', 'entusiasta'] },
  { value: '🤔', label: 'Thinking', keywords: ['thinking', 'pensare', 'idea', 'analysis', 'analisi', 'valutare'] },
  { value: '🧐', label: 'Inspect', keywords: ['inspect', 'controllare', 'review', 'revisione', 'detailed', 'dettaglio'] },
  { value: '😴', label: 'Sleepy', keywords: ['sleep', 'sonno', 'tired', 'stanco', 'night', 'notte'] },
  { value: '😤', label: 'Determined', keywords: ['determined', 'determinato', 'push', 'impegno', 'focus', 'concentrazione'] },
  { value: '😱', label: 'Surprised', keywords: ['surprised', 'sorpresa', 'shock', 'inaspettato', 'wow'] },
  { value: '😡', label: 'Angry', keywords: ['angry', 'arrabbiato', 'issue', 'problema', 'frustrated', 'frustrato'] },
  { value: '😢', label: 'Sad', keywords: ['sad', 'triste', 'disappointed', 'deluso', 'unhappy'] },
  { value: '🤗', label: 'Support', keywords: ['support', 'supporto', 'hug', 'abbraccio', 'team', 'squadra'] },
  { value: '🙏', label: 'Thanks', keywords: ['thanks', 'grazie', 'please', 'per favore', 'respect', 'rispetto'] },
  { value: '👋', label: 'Hello', keywords: ['hello', 'ciao', 'welcome', 'benvenuto', 'bye', 'arrivederci'] },
  { value: '👍', label: 'Approve', keywords: ['approve', 'ok', 'yes', 'si', 'approved', 'approvato'] },
  { value: '👎', label: 'Reject', keywords: ['reject', 'no', 'denied', 'negato', 'disagree', 'disaccordo'] },
  { value: '👏', label: 'Applause', keywords: ['applause', 'applausi', 'good job', 'bravo', 'complimenti'] },
  { value: '💪', label: 'Strength', keywords: ['strength', 'forza', 'power', 'energia', 'resilience', 'resilienza'] },
  { value: '🙌', label: 'Great', keywords: ['great', 'ottimo', 'celebration', 'celebrazione', 'done', 'fatto'] },
  { value: '🤝', label: 'Handshake', keywords: ['handshake', 'accordo', 'deal', 'partnership', 'collaborazione'] },
  { value: '🤖', label: 'Robot', keywords: ['robot', 'ai', 'automation', 'automazione', 'bot', 'intelligenza artificiale'] },
  { value: '🧠', label: 'Brain', keywords: ['brain', 'cervello', 'strategy', 'strategia', 'thinking', 'pensiero'] },
  { value: '💡', label: 'Idea', keywords: ['idea', 'concept', 'concetto', 'innovation', 'innovazione', 'insight'] },
  { value: '⚙️', label: 'Settings', keywords: ['settings', 'impostazioni', 'configuration', 'configurazione', 'gear', 'ingranaggio'] },
  { value: '🛠️', label: 'Tools', keywords: ['tools', 'strumenti', 'fix', 'riparare', 'maintenance', 'manutenzione'] },
  { value: '🔧', label: 'Wrench', keywords: ['wrench', 'chiave inglese', 'setup', 'installazione', 'repair', 'riparazione'] },
  { value: '🔍', label: 'Search', keywords: ['search', 'ricerca', 'find', 'trovare', 'lookup', 'cercare'] },
  { value: '🔎', label: 'Inspect', keywords: ['inspect', 'ispezione', 'zoom', 'dettaglio', 'analysis', 'analisi'] },
  { value: '🔐', label: 'Secure', keywords: ['secure', 'sicuro', 'security', 'sicurezza', 'protected', 'protetto'] },
  { value: '🔑', label: 'Key', keywords: ['key', 'chiave', 'access', 'accesso', 'permission', 'permesso'] },
  { value: '🧩', label: 'Puzzle', keywords: ['puzzle', 'modulo', 'piece', 'pezzo', 'integration', 'integrazione'] },
  { value: '🧪', label: 'Test', keywords: ['test', 'qa', 'quality', 'qualità', 'experiment', 'esperimento'] },
  { value: '🧬', label: 'DNA', keywords: ['dna', 'science', 'scienza', 'research', 'ricerca', 'lab', 'laboratorio'] },
  { value: '📡', label: 'Signal', keywords: ['signal', 'segnale', 'network', 'rete', 'communication', 'comunicazione'] },
  { value: '🛰️', label: 'Satellite', keywords: ['satellite', 'space', 'spazio', 'global', 'mondiale', 'signal', 'segnale'] },
  { value: '🌐', label: 'Web', keywords: ['web', 'internet', 'online', 'globale', 'network', 'rete'] },
  { value: '🌍', label: 'World', keywords: ['world', 'mondo', 'global', 'internazionale', 'earth', 'terra'] },
  { value: '☁️', label: 'Cloud', keywords: ['cloud', 'nuvola', 'infrastructure', 'infrastruttura', 'hosting'] },
  { value: '💾', label: 'Save', keywords: ['save', 'salva', 'disk', 'disco', 'storage', 'archiviazione'] },
  { value: '📁', label: 'Folder', keywords: ['folder', 'cartella', 'files', 'file', 'archive', 'archivio'] },
  { value: '🗂️', label: 'Organizer', keywords: ['organizer', 'organizzazione', 'documents', 'documenti', 'classification', 'classificazione'] },
  { value: '📦', label: 'Package', keywords: ['package', 'pacchetto', 'delivery', 'consegna', 'bundle'] },
  { value: '📚', label: 'Knowledge', keywords: ['books', 'libri', 'knowledge', 'conoscenza', 'documentation', 'documentazione'] },
  { value: '📝', label: 'Notes', keywords: ['notes', 'note', 'write', 'scrivere', 'memo', 'promemoria'] },
  { value: '📌', label: 'Pin', keywords: ['pin', 'fissa', 'important', 'importante', 'highlight', 'evidenza'] },
  { value: '📎', label: 'Attachment', keywords: ['attachment', 'allegato', 'clip', 'file', 'upload', 'caricare'] },
  { value: '📋', label: 'Checklist', keywords: ['checklist', 'lista', 'tasks', 'attività', 'to do', 'da fare'] },
  { value: '📅', label: 'Calendar', keywords: ['calendar', 'calendario', 'date', 'data', 'schedule', 'pianificazione'] },
  { value: '🕒', label: 'Time', keywords: ['time', 'tempo', 'clock', 'orario', 'deadline', 'scadenza'] },
  { value: '⏰', label: 'Alarm', keywords: ['alarm', 'promemoria', 'reminder', 'sveglia', 'urgent', 'urgente'] },
  { value: '📣', label: 'Announcement', keywords: ['announcement', 'annuncio', 'broadcast', 'comunicato', 'notice', 'avviso'] },
  { value: '📢', label: 'Megaphone', keywords: ['megaphone', 'megafono', 'marketing', 'promozione', 'campaign', 'campagna'] },
  { value: '💬', label: 'Message', keywords: ['message', 'messaggio', 'chat', 'conversation', 'conversazione'] },
  { value: '🗣️', label: 'Speak', keywords: ['speak', 'parlare', 'voice', 'voce', 'presentation', 'presentazione'] },
  { value: '📞', label: 'Call', keywords: ['call', 'telefonata', 'phone', 'telefono', 'support', 'assistenza'] },
  { value: '📧', label: 'Email', keywords: ['email', 'mail', 'posta', 'messaggio', 'communication', 'comunicazione'] },
  { value: '📨', label: 'Inbox', keywords: ['inbox', 'posta in arrivo', 'received', 'ricevuto', 'messages', 'messaggi'] },
  { value: '📤', label: 'Send', keywords: ['send', 'inviare', 'outbox', 'uscita', 'deliver', 'spedire'] },
  { value: '📊', label: 'Bar Chart', keywords: ['chart', 'grafico', 'data', 'dati', 'analytics', 'analisi'] },
  { value: '📈', label: 'Growth', keywords: ['growth', 'crescita', 'trend', 'andamento', 'increase', 'aumento'] },
  { value: '📉', label: 'Decline', keywords: ['decline', 'calo', 'drop', 'diminuzione', 'decrease'] },
  { value: '🧾', label: 'Receipt', keywords: ['receipt', 'ricevuta', 'invoice', 'fattura', 'expense', 'spesa'] },
  { value: '💳', label: 'Card', keywords: ['card', 'carta', 'payment', 'pagamento', 'credit', 'credito'] },
  { value: '💰', label: 'Money', keywords: ['money', 'soldi', 'budget', 'finanza', 'cash', 'contanti'] },
  { value: '🏦', label: 'Bank', keywords: ['bank', 'banca', 'finance', 'finanza', 'account', 'conto'] },
  { value: '🏢', label: 'Office', keywords: ['office', 'ufficio', 'company', 'azienda', 'building', 'edificio'] },
  { value: '🏭', label: 'Factory', keywords: ['factory', 'fabbrica', 'production', 'produzione', 'industry', 'industria'] },
  { value: '👥', label: 'Team', keywords: ['team', 'squadra', 'people', 'persone', 'group', 'gruppo'] },
  { value: '🧑‍💼', label: 'Professional', keywords: ['professional', 'professionista', 'manager', 'lavoro', 'business'] },
  { value: '🧑‍💻', label: 'Developer', keywords: ['developer', 'sviluppatore', 'code', 'codice', 'programming', 'programmazione'] },
  { value: '🧑‍🔧', label: 'Technician', keywords: ['technician', 'tecnico', 'maintenance', 'manutenzione', 'repair', 'riparazione'] },
  { value: '🧑‍🏫', label: 'Trainer', keywords: ['trainer', 'formatore', 'teacher', 'insegnante', 'training', 'formazione'] },
  { value: '🧑‍⚖️', label: 'Legal', keywords: ['legal', 'legale', 'compliance', 'normativa', 'law', 'diritto'] },
  { value: '🧑‍🚒', label: 'Emergency', keywords: ['emergency', 'emergenza', 'firefighter', 'sicurezza', 'risk', 'rischio'] },
  { value: '🎯', label: 'Target', keywords: ['target', 'obiettivo', 'goal', 'focus', 'kpi', 'risultato'] },
  { value: '🚀', label: 'Launch', keywords: ['launch', 'lancio', 'go live', 'rilascio', 'startup', 'avvio'] },
  { value: '🏁', label: 'Finish', keywords: ['finish', 'fine', 'completed', 'completato', 'done', 'chiuso'] },
  { value: '✅', label: 'Done', keywords: ['done', 'fatto', 'success', 'successo', 'approved', 'approvato'] },
  { value: '❌', label: 'Cancelled', keywords: ['cancel', 'annullato', 'stop', 'errore', 'remove', 'rimuovere'] },
  { value: '⚠️', label: 'Warning', keywords: ['warning', 'attenzione', 'risk', 'rischio', 'alert', 'avviso'] },
  { value: '🚫', label: 'Blocked', keywords: ['blocked', 'bloccato', 'forbidden', 'vietato', 'not allowed', 'non consentito'] },
  { value: '⛔', label: 'No Entry', keywords: ['no entry', 'divieto', 'restriction', 'restrizione', 'access denied', 'accesso negato'] },
  { value: '🔁', label: 'Repeat', keywords: ['repeat', 'ripeti', 'loop', 'ciclo', 'again', 'di nuovo'] },
  { value: '🔄', label: 'Refresh', keywords: ['refresh', 'aggiorna', 'sync', 'sincronizza', 'reload', 'ricarica'] },
  { value: '↗️', label: 'External Link', keywords: ['external', 'esterno', 'open', 'aprire', 'redirect', 'reindirizzare'] },
  { value: '📍', label: 'Location', keywords: ['location', 'posizione', 'map', 'mappa', 'place', 'luogo'] },
  { value: '🗺️', label: 'Map', keywords: ['map', 'mappa', 'route', 'percorso', 'navigation', 'navigazione'] },
  { value: '🚗', label: 'Car', keywords: ['car', 'macchina', 'transportation', 'transfer', 'mezzi', 'trasporto', 'travel', 'viaggio'] },
  { value: '🚕', label: 'Taxi', keywords: ['taxi', 'cab', 'transfer', 'trasferimento', 'city', 'città'] },
  { value: '🚌', label: 'Bus', keywords: ['bus', 'mezzi pubblici', 'transport', 'trasporto', 'commute', 'pendolare'] },
  { value: '🚆', label: 'Train', keywords: ['train', 'treno', 'rail', 'ferrovia', 'trip', 'viaggio'] },
  { value: '✈️', label: 'Flight', keywords: ['flight', 'volo', 'plane', 'aereo', 'travel', 'viaggio'] },
  { value: '🛫', label: 'Departure', keywords: ['departure', 'partenza', 'takeoff', 'decollo', 'airport', 'aeroporto'] },
  { value: '🛬', label: 'Arrival', keywords: ['arrival', 'arrivo', 'landing', 'atterraggio', 'airport', 'aeroporto'] },
  { value: '🚢', label: 'Ship', keywords: ['ship', 'nave', 'logistics', 'logistica', 'cargo', 'carico'] },
  { value: '🏨', label: 'Hotel', keywords: ['hotel', 'alloggio', 'stay', 'soggiorno', 'room', 'camera'] },
  { value: '🍽️', label: 'Meal', keywords: ['meal', 'pasto', 'dinner', 'cena', 'lunch', 'pranzo'] },
  { value: '☕', label: 'Coffee', keywords: ['coffee', 'caffè', 'break', 'pausa', 'drink', 'bevanda'] },
  { value: '🍕', label: 'Pizza', keywords: ['pizza', 'food', 'cibo', 'lunch', 'pranzo', 'dinner', 'cena'] },
  { value: '🥗', label: 'Salad', keywords: ['salad', 'insalata', 'healthy', 'sano', 'food', 'cibo'] },
  { value: '🍎', label: 'Apple', keywords: ['apple', 'mela', 'fruit', 'frutta', 'healthy', 'salute'] },
  { value: '🎉', label: 'Party Popper', keywords: ['party', 'festa', 'celebration', 'celebrazione', 'event', 'evento'] },
  { value: '🎊', label: 'Confetti', keywords: ['confetti', 'evento', 'celebration', 'festeggiare', 'party'] },
  { value: '🎁', label: 'Gift', keywords: ['gift', 'regalo', 'bonus', 'premio', 'surprise', 'sorpresa'] },
  { value: '🏆', label: 'Trophy', keywords: ['trophy', 'trofeo', 'winner', 'vincitore', 'award', 'premio'] },
  { value: '🥇', label: 'First Place', keywords: ['first', 'primo', 'gold', 'oro', 'ranking', 'classifica'] },
  { value: '🎓', label: 'Graduation', keywords: ['graduation', 'laurea', 'learning', 'apprendimento', 'education', 'formazione'] },
  { value: '📷', label: 'Camera', keywords: ['camera', 'foto', 'image', 'immagine', 'shoot', 'scatto'] },
  { value: '🎬', label: 'Video', keywords: ['video', 'film', 'recording', 'registrazione', 'media', 'contenuti'] },
  { value: '🎵', label: 'Music', keywords: ['music', 'musica', 'audio', 'sound', 'suono'] },
  { value: '🔔', label: 'Bell', keywords: ['bell', 'campanella', 'notification', 'notifica', 'alert', 'avviso'] },
  { value: '📫', label: 'Mailbox', keywords: ['mailbox', 'casella', 'post', 'posta', 'message', 'messaggio'] },
  { value: '🗑️', label: 'Trash', keywords: ['trash', 'cestino', 'delete', 'eliminare', 'remove', 'rimuovere'] },
  { value: '♻️', label: 'Recycle', keywords: ['recycle', 'riciclo', 'reuse', 'riuso', 'sustainability', 'sostenibilità'] },
  { value: '🧹', label: 'Clean', keywords: ['clean', 'pulire', 'cleanup', 'pulizia', 'tidy', 'riordinare'] },
  { value: '🧯', label: 'Extinguisher', keywords: ['extinguisher', 'estintore', 'safety', 'sicurezza', 'risk', 'rischio'] },
  { value: '🌱', label: 'Growth Seed', keywords: ['growth', 'crescita', 'seed', 'seme', 'new', 'nuovo'] },
  { value: '🌳', label: 'Tree', keywords: ['tree', 'albero', 'nature', 'natura', 'environment', 'ambiente'] },
  { value: '🌞', label: 'Sun', keywords: ['sun', 'sole', 'day', 'giorno', 'positive', 'positivo'] },
  { value: '🌙', label: 'Moon', keywords: ['moon', 'luna', 'night', 'notte', 'calm', 'calma'] },
  { value: '⭐', label: 'Star', keywords: ['star', 'stella', 'favorite', 'preferito', 'highlight', 'evidenza'] },
  { value: '✨', label: 'Sparkles', keywords: ['sparkles', 'scintille', 'magic', 'magia', 'shine', 'brillare'] },
  { value: '⚡', label: 'Lightning', keywords: ['lightning', 'fulmine', 'fast', 'veloce', 'energy', 'energia'] },
  { value: '❄️', label: 'Snow', keywords: ['snow', 'neve', 'cold', 'freddo', 'winter', 'inverno'] },
  { value: '🔥', label: 'Fire', keywords: ['fire', 'fuoco', 'hot', 'caldo', 'urgent', 'urgente'] },
  { value: '💥', label: 'Impact', keywords: ['impact', 'impatto', 'boom', 'strong', 'forte'] },
  { value: '🟥', label: 'Red', keywords: ['red', 'rosso', 'critical', 'critico', 'stop'] },
  { value: '🟨', label: 'Yellow', keywords: ['yellow', 'giallo', 'warning', 'attenzione', 'pending', 'in attesa'] },
  { value: '🟩', label: 'Green', keywords: ['green', 'verde', 'ok', 'success', 'successo', 'go'] },
  { value: '🟦', label: 'Blue', keywords: ['blue', 'blu', 'info', 'informazioni', 'calm', 'calma'] },
  { value: '⬆️', label: 'Up', keywords: ['up', 'su', 'increase', 'aumento', 'higher', 'più alto'] },
  { value: '⬇️', label: 'Down', keywords: ['down', 'giù', 'decrease', 'diminuzione', 'lower', 'più basso'] },
  { value: '➡️', label: 'Next', keywords: ['next', 'prossimo', 'forward', 'avanti', 'continue', 'continua'] },
  { value: '⬅️', label: 'Back', keywords: ['back', 'indietro', 'previous', 'precedente', 'return', 'ritorno'] }
]

const DEFAULT_EMOJI_BY_VALUE = Object.fromEntries(DEFAULT_EMOJIS.map((emoji) => [emoji.value, emoji]))

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  position: relative;
`

const Label = styled.label`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.muted};
`

const Trigger = styled.button`
  width: 100%;
  border: 1px solid ${({ theme, $isOpen }) => ($isOpen ? theme.colors.primary : theme.colors.border)};
  border-radius: ${({ theme }) => theme.radii.md};
  height: 40px;
  padding: 0 12px;
  background: white;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  box-shadow: ${({ theme, $isOpen }) => ($isOpen ? `0 0 0 3px ${theme.colors.primary}33` : 'none')};
  transition: all 0.2s ease;
`

const TriggerValue = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`

const Arrow = styled.span`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.muted};
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.2s ease;
`

const Popover = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.md};
  box-shadow: ${({ theme }) => theme.shadow.lg};
  z-index: 9999;
  padding: 8px;
  max-height: 360px;
  display: flex;
  flex-direction: column;
`

const SearchInput = styled.input`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.sm};
  padding: 8px 10px;
  font-size: 13px;
  outline: none;
  margin-bottom: 8px;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => `${theme.colors.primary}33`};
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(10, minmax(0, 1fr));
  gap: 6px;
  min-height: 0;
  overflow-y: auto;
  max-height: 300px;
  overscroll-behavior: contain;
`

const EmojiButton = styled.button`
  border: 1px solid ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.border)};
  background: ${({ theme, $active }) => ($active ? `${theme.colors.primary}14` : 'white')};
  border-radius: ${({ theme }) => theme.radii.sm};
  height: 32px;
  width: 32px;
  cursor: pointer;
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${({ theme, $active }) => ($active ? `${theme.colors.primary}1f` : theme.colors.background)};
  }
`

const EmptyState = styled.div`
  padding: 12px;
  text-align: center;
  color: ${({ theme }) => theme.colors.muted};
  font-size: 12px;
`

export function EmojiSelector({
  label,
  value,
  onChange,
  options = DEFAULT_EMOJIS,
  placeholder = 'Select emoji',
  disabled,
  searchPlaceholder = 'Search emoji...'
}) {
  const [isOpen, setIsOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const containerRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    if (!isOpen) setSearchTerm('')
  }, [isOpen])

  const normalizedOptions = useMemo(() => {
    const normalizeText = (input) => {
      if (typeof input !== 'string') return ''
      return input
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
    }

    const normalizeKeywords = (input) => {
      if (!Array.isArray(input)) return []
      return input
        .map((item) => (typeof item === 'string' ? normalizeText(item) : ''))
        .filter(Boolean)
    }

    return Array.isArray(options)
      ? options
          .map((opt) => {
            if (typeof opt === 'string') {
              const defaultEntry = DEFAULT_EMOJI_BY_VALUE[opt]
              if (defaultEntry) {
                return {
                  value: defaultEntry.value,
                  label: defaultEntry.label,
                  keywords: normalizeKeywords(defaultEntry.keywords)
                }
              }
              return {
                value: opt,
                label: opt,
                keywords: [normalizeText(opt)]
              }
            }

            if (!opt || typeof opt.value !== 'string') return null

            const defaultEntry = DEFAULT_EMOJI_BY_VALUE[opt.value]
            const providedKeywords = Array.isArray(opt.keywords) ? opt.keywords : []
            const mergedKeywords = normalizeKeywords([
              ...(defaultEntry?.keywords || []),
              ...providedKeywords,
              opt.label,
              opt.searchText
            ])

            return {
              value: opt.value,
              label: typeof opt.label === 'string' && opt.label.trim() ? opt.label : defaultEntry?.label || opt.value,
              keywords: Array.from(new Set(mergedKeywords))
            }
          })
          .filter(Boolean)
      : []
  }, [options])

  const filteredOptions = useMemo(() => {
    const query = searchTerm
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
    if (!query) return normalizedOptions

    const terms = query.split(/\s+/).filter(Boolean)

    return normalizedOptions.filter((opt) => {
      const haystack = `${opt.value} ${opt.label || ''} ${(opt.keywords || []).join(' ')}`
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      return terms.every((term) => haystack.includes(term))
    })
  }, [normalizedOptions, searchTerm])

  const selectedOption = normalizedOptions.find((opt) => opt.value === value)
  const selectedLabel = selectedOption ? selectedOption.label : ''

  return (
    <Wrapper ref={containerRef}>
      {label && <Label>{label}</Label>}
      <Trigger
        type="button"
        onClick={() => !disabled && setIsOpen((prev) => !prev)}
        $isOpen={isOpen}
        disabled={disabled}
      >
        <TriggerValue>
          <span style={{ fontSize: '20px', lineHeight: 1 }}>{value || '🙂'}</span>
          <span>{value ? selectedLabel || value : placeholder}</span>
        </TriggerValue>
        <Arrow $isOpen={isOpen}>▼</Arrow>
      </Trigger>
      {isOpen && (
        <Popover>
          <SearchInput
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={searchPlaceholder}
          />
          {filteredOptions.length > 0 ? (
            <Grid>
              {filteredOptions.map((opt) => (
                <EmojiButton
                  key={opt.value}
                  type="button"
                  $active={opt.value === value}
                  onClick={() => {
                    onChange && onChange(opt.value)
                    setIsOpen(false)
                  }}
                  aria-label={opt.label || opt.value}
                >
                  {opt.value}
                </EmojiButton>
              ))}
            </Grid>
          ) : (
            <EmptyState>No emoji found</EmptyState>
          )}
        </Popover>
      )}
    </Wrapper>
  )
}
